import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";
import classNames from "classnames";

class Payment extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  static getDerivedStateFromProps(props, state) {

    return null;
  }

  componentDidMount = () => {
  }

  componentDidUpdate(_, prevState) {
    
  }

  componentWillUnmount() {
  }

  async submitPaypal() {
    const {
      updateOnboardingStep,
    } = this.props;

    const email = document.getElementById('paypal_email').value.toLowerCase().trim();
    if (!email.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i)) {
      this.setState({ invalidEmail: true });
    } else {
      const response = await sendAPIRequest(`/onboarding/submit_paypal_email`, "POST", { email });
      if (response.data.status == 'success') {
        updateOnboardingStep(response.data.onboardingStep);
      } else {
        throw new Error("invalid status for paypal email set: " + response.data.status)
      }
    }
  }

  render() {
    const {
      currentContractor,
    } = this.props;

    const {
      invalidEmail
    } = this.state;

    const nameClasses = classNames({
      'onboarding-input': true,
      'onboarding-input-wider': true,
      'onboarding-input-invalid': !!invalidEmail,
    });

    const errorClasses = classNames({
      'onboarding-biglabel': true,
      'onboarding-error-label': true,
      'onboarding-error-label-hidden': !invalidEmail,
    });

    return (
      <div className="onboarding-paypal-container">
        <div className="onboarding-title">
          Enter Your PayPal Information
        </div>
        <div className="onboarding-biglabel onboarding-paypal-subtitle">
          We use Paypal to pay you every week for your transcription. Please enter your PayPal Email below.
        </div>
        <div className="onboarding-label">PAYPAL EMAIL</div>
        <br />
        <input className={nameClasses} id="paypal_email" placeholder="name@email.com" />
        <div className="onboarding-paypal-body">
          Make sure you use your PayPal email address and NOT your account number, PayPal.Me link, or anything else. Ensure that there are no unnecessary spaces anywhere. Failure to enter your PayPal email and unnecessary spaces means we will not be able to pay you.
          <br /> <br />
          Make sure you enter YOUR PayPal and not anyone else{"'"}s, do not share a PayPal with anyone else. QA World is not responsible if you share an account your payment gets mixed up with your partner.
          <br /> <br />
          If you do not have a PayPal you can set one up here: <a href="https://www.paypal.com">www.paypal.com</a> Extra instructions about how to set up a paypal account can be found here.
        </div>
        <div className="onboarding-divider"/>
        <div className="onboarding-submission">
          <div className={errorClasses}>
            <svg className="onboarding-error-icon" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10.5" cy="10.5" r="10.5" fill="#F23D60"/>
            </svg>
            <svg className="onboarding-error-icon-point" width="3" height="13" viewBox="0 0 3 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.023 8.345L0.751 2.548L0.7 0.61H2.672L2.604 2.548L2.332 8.345H1.023ZM1.686 12.204C1.32333 12.204 1.01733 12.0793 0.768 11.83C0.53 11.5807 0.411 11.2633 0.411 10.878C0.411 10.4927 0.53 10.1753 0.768 9.926C1.01733 9.67667 1.32333 9.552 1.686 9.552C2.04867 9.552 2.349 9.67667 2.587 9.926C2.825 10.1753 2.944 10.4927 2.944 10.878C2.944 11.2633 2.825 11.5807 2.587 11.83C2.349 12.0793 2.04867 12.204 1.686 12.204Z" fill="white"/>
            </svg>
            You have not entered a valid email address, please try again.
          </div>
          <Button className="onboarding-submission-button" onClick={() => this.submitPaypal()} text="Continue" />
        </div>
      </div>
    );
  }

}

export default Payment;
